module.exports = __webpack_public_path__ + "img/ad3.fc423b17.png";